import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Site from "@/pages/Site";
import ServicePage from "@/pages/ServicePage";
import BookPage from "@/pages/BookPage";
import RedirectFromOldWix from "@/components/RedirectFromOldWix";
import { Toaster } from "@/components/ui/sonner";
import { WIX_REDIRECTS } from "@/lib/redirects";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />

          {/* Dedicated, indexable service landing pages — each with own URL,
              title, meta description, canonical, H1, JSON-LD and 400+ words. */}
          <Route path="/studio-hire" element={<ServicePage slug="studio-hire" />} />
          <Route path="/production" element={<ServicePage slug="production" />} />
          <Route path="/photography-video" element={<ServicePage slug="photography-video" />} />
          <Route path="/headshots" element={<ServicePage slug="headshots" />} />
          <Route path="/equipment" element={<ServicePage slug="equipment" />} />
          <Route path="/retouching" element={<ServicePage slug="retouching" />} />
          <Route path="/props-and-furniture" element={<ServicePage slug="props-and-furniture" />} />

          {/* Extra SEO landing pages — not linked from menu or related-services grid.
              Reachable only via direct URL / Google search / sitemap. */}
          <Route path="/studio-hire-london" element={<ServicePage slug="studio-hire-london" />} />
          <Route path="/headshots-london" element={<ServicePage slug="headshots-london" />} />
          <Route path="/for-brands" element={<ServicePage slug="for-brands" />} />
          <Route path="/for-agencies" element={<ServicePage slug="for-agencies" />} />
          <Route path="/photography-studio-east-london" element={<ServicePage slug="photography-studio-east-london" />} />

          {/* Dedicated booking / contact page */}
          <Route path="/book" element={<BookPage />} />

          {/* Old Wix paths → 301-equivalent client-side redirect */}
          {Object.keys(WIX_REDIRECTS).map((p) => (
            <Route key={p} path={p} element={<RedirectFromOldWix />} />
          ))}
          <Route path="*" element={<Site />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
